import Page from "~/pages/Page";
import { getApi, handleError, logout } from "~/auth";
import * as validation from "~/utils/validation";
import UI from "~/ui";
import { gotoLogin } from "~/utils";
import { startCountdown, stopCountdown } from "~/utils/CountdownTimer";
import { initializeInputMasks } from "~/input-mask";
import { t } from "~/hooks/useI18n";
import { finishAuctionInfoLoading } from "~/pages/areariservata/AuctionInfoLoading";
import { initTablePlus, attachExpandListeners } from '~/tablePlus';

declare global {
    interface Window {
        updateExpandButtons?: () => void;
    }
}

class AtStatoAsta extends Page {

    // Salva l'indice della riga espansa (se presente)
    private expandedRowIndexes: number[] = [];

    private auth: any = null;
    private userInfo: any = null; // Variabile globale per memorizzare le informazioni dell'utente
    private UserId: number = 0; // Aggiungi l'ID dell'utente
    private userIdAT: number = 0; // Aggiungi l'ID dell'utente
    private offerente: string = "";
    private pin: string = "";

    private venditoreId: number = Number($("#hdVenditoreId").val()) || 0;
    private IdAsteTelematiche: number = 0;
    private culture: string = (window as any).currenCulture || "it-IT";
    private pollingId: number | null = null;

    private statoIscrizione: number | null = null;
    private migliorOfferente: number | null = null;
    private migliorOfferentePrecedente: number | null = null;
    private miglioreOfferta: number | null = null;
    private rilancioMinimo: number = 0;
    private astaConclusa: boolean = false;

    // ✅ Aggiungi variabile per tracciare lo stato corrente
    private statoGaraCorrente: number = 0; // 0 = sconosciuto, 1 = da iniziare, 2 = in corso, ecc.

    private countdownInitialized: boolean = false;
    private countdownTimerId: number | null = null; // ✅ NUOVO

    constructor() {
        super("atstatoastaacquirente", "AT Stato Asta Acquirente");
    }

    async pageStart(): Promise<void> {
        const that = this;

        initializeInputMasks();

        this.auth = getApi();
        this.userInfo = this.auth.getCached("userInfo"); // Inizializza la variabile globale
        if (!this.userInfo) {
            gotoLogin();
            return Promise.reject("User not authenticated");
        }

        this.UserId = this.userInfo.anagraficaId; // Inizializza l'ID dell'utente

        this.IdAsteTelematiche = Number($("#hdIdAsteTelematiche").val());
        //this.offerente = $("#hdNomeOfferente").val() as string;
        this.offerente = this.userInfo.cognome + " " + this.userInfo.nome;
        this.userIdAT = Number($("#hdATUserId").val());
        this.migliorOfferente = Number($("#ATBestOfferId").val());

        let _ = this.spinner.spin();
        try {
            initTablePlus();
            // ✅ 1. Prima chiamata iniziale (tutte e 4 le API)
            await this.InitialLoad();
        } catch (error) {
            console.error("Errore durante il caricamento iniziale:", error);
        } finally {
            this.spinner.stop();
        }

        // ✅ 2. Poi avvia il polling con logica condizionale basata su statoGaraCorrente
        if (this.statoGaraCorrente == 1 || this.statoGaraCorrente == 2)
            this.StarPolling();


        // Event listeners
        $("#btnRilancia").on("click", (e) => {
            e.preventDefault();
            $('#modalRilancioAsta').modal("show");
        });

        $("#btnRilancioAsta").on("click", (e) => {
            e.preventDefault();
            this.StopPolling();
            this.InviaRilancio();
        });

        $('#modalRilancioAsta').on('hidden.bs.modal', (e) => {
            $("#txtRilancio").val("");
        });

        // ✅ Usa arrow function
        $('#modalRilancioAsta').on('show.bs.modal', (e) => {
            $("#ATResultMessage").html("");
            this.StopPolling();
            this.RefreshDatiAsta();
        });


        return Promise.resolve();
    }

    // ✅ Nuovo metodo per il caricamento iniziale
    private async InitialLoad(): Promise<void> {
        console.info("📥 Caricamento iniziale dati asta...");

        try {
            // 1. Prima chiama RefreshDatiAsta per popolare statoGaraCorrente
            await this.RefreshStatoIscrizione();
            await this.RefreshDatiAsta();

            // 2. Poi esegui le altre 3 chiamate in parallelo (più veloce)
            await Promise.all([
                this.RefreshListaOfferteIniziali(),
                this.RefreshListaRilanciOmissis(),
            ]);

            console.info(`✅ Caricamento iniziale completato (Stato: ${this.statoGaraCorrente})`);
        } catch (error) {
            console.error("❌ Errore nel caricamento iniziale:", error);
        } finally {
            finishAuctionInfoLoading();
        }
    }

    private StarPolling(): void {
        this.pollingId = window.setInterval(() => {
            // ✅ Chiama sempre RefreshDatiAsta per aggiornare lo stato
            this.RefreshDatiAsta().then(() => {
                // ✅ Crea un array di promesse condizionali
                const promises: Promise<void>[] = [];

                // ✅ RefreshListaOfferteIniziali solo se stato = 1 (da iniziare)
                if (this.statoGaraCorrente === 1) {
                    promises.push(this.RefreshListaOfferteIniziali());

                }

                // ✅ RefreshListaRilanciOmissis solo se stato = 2 (in corso)
                if (this.statoGaraCorrente == 2) {
                    promises.push(this.RefreshListaRilanciOmissis());
                    if (this.statoIscrizione != 3) {
                        promises.push(this.RefreshStatoIscrizione());
                    }
                }

                // ✅ RefreshStatoIscrizione sempre, tranne se 3 (conclusa) / 4 (aggiudicata) / 5 (chiusa)
                if (this.statoGaraCorrente != 3 && this.statoGaraCorrente !== 4 && this.statoGaraCorrente !== 5) {
                    promises.push(this.RefreshStatoIscrizione());
                }

                return Promise.all(promises);
            }).catch(err => console.error("Errore nel polling:", err));

            console.info(`Polling... (Stato: ${this.statoGaraCorrente})`);
        }, 5000);
    }

    private StopPolling(): void {
        if (this.pollingId !== null) {
            clearInterval(this.pollingId);
            this.pollingId = null;
            console.info("STOP polling");
        }

        // ✅ OPZIONE A: Ferma tramite ID locale (più preciso)
        if (this.countdownTimerId !== null) {
            clearInterval(this.countdownTimerId);
            this.countdownTimerId = null;
            this.countdownInitialized = false;
            console.info("STOP countdown (local)");
        }

        // ✅ OPZIONE B: Ferma anche globalmente (per sicurezza)
        stopCountdown(); // Se esiste nel modulo
    }

    private async RefreshDatiAsta() {

        if (this.IdAsteTelematiche > 0) {
            const url = window.BaseUrlWebApi + "AsteTelematiche/StatoVendita?idAstaTelematica=" + this.IdAsteTelematiche;
            const statoAsta = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!statoAsta || statoAsta.length === 0) {
                return;
            }

            await this.PopolaInfoAsta(statoAsta);
        }
    }

    private async RefreshListaRilanciOmissis() {

        if (this.IdAsteTelematiche > 0) {
            const url = window.BaseUrlWebApi + "AsteTelematiche/ListaRilanciOmissis?idAstaTelematica=" + this.IdAsteTelematiche;
            const rilanci = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            this.PopolaTabella(rilanci);
        }
    }

    private async RefreshListaOfferteIniziali() {

        if (this.IdAsteTelematiche > 0) {
            const url = window.BaseUrlWebApi + "AsteTelematiche/ListaOfferteIniziali?idAstaTelematica=" + this.IdAsteTelematiche;
            const offerteIniziali = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!offerteIniziali || offerteIniziali.length === 0) {
                return;
            }

            this.PopolaTabellaOfferteIniziali(offerteIniziali);
        }
    }

    private async RefreshStatoIscrizione() {
        this.userIdAT = $("#hdATUserId").val() as number;
        this.pin = $("#hdPin").val() as string;
        if (this.IdAsteTelematiche > 0 && this.userIdAT > 0 && this.pin) {
            const url = window.BaseUrlWebApi + "AsteTelematiche/StatoIscrizione?idAstaTelematica=" + this.IdAsteTelematiche + "&utenteId=" + this.userIdAT + "&pin=" + this.pin;
            const statoIscrizione = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!statoIscrizione || statoIscrizione.length === 0) {
                return;
            }

            this.StatoIscrizione(statoIscrizione);
        }
    }

    private async PopolaInfoAsta(obj: any) {

        //Input nascosti
        $("#ATBestOfferId").val(obj.MigliorOfferente);
        $("#hdRilancioMinimo").val(obj.RialzoMinimo);

        //Dati partial "/AstaTelematica/_InfoTipoAsta 1 o 2"
        $("#data-inizio-presentazione-offerte").html(UI.formatDateIsoToIt(obj.DataInizioCauzione));
        $("#ora-inizio-presentazione-offerte").html(UI.formatTimeIsoToHms(obj.DataInizioCauzione));
        $("#data-fine-presentazione-offerte").html(UI.formatDateIsoToIt(obj.DataFineCauzione));
        $("#ora-fine-presentazione-offerte").html(UI.formatTimeIsoToHms(obj.DataFineCauzione));
        $("#data-inizio-gara").html(UI.formatDateIsoToIt(obj.DataInizio));
        $("#ora-inizio-gara").html(UI.formatTimeIsoToHms(obj.DataInizio));
        $("#data-fine-gara").html(UI.formatDateIsoToIt(obj.DataFine));
        $("#ora-fine-gara").html(UI.formatTimeIsoToHms(obj.DataFine));


        //DATI PARTIAL "/AstaTelematica/_InformazioniGara"
        $("#prezzo-base").html(UI.formatEuroCurrency(obj.PrezzoBase));
        if (obj.PrezzoRiserva > 0) {
            $("#prezzo-riserva").html(UI.formatEuroCurrency(obj.PrezzoRiserva));

        } else {
            $("#li-offerta-minima").addClass("d-none");
        }

        // ✅ Formatta cauzione
        const tipoCauzione = await this.getTipoCauzioneLabel(obj.TipoCauzione);
        $("#tipo-cauzione").html(tipoCauzione);
        if (obj.TipoCauzione == 1) {
            $("#cauzione").html(UI.formatEuroCurrency(obj.Cauzione));
        } else {
            $("#cauzione").html(obj.Cauzione + " " + tipoCauzione);
        }

        // ✅ Gestione corretta del rilancio minimo (può essere numero o stringa)
        const rilancioMin = obj.RialzoMinimo ?? 0;
        if (typeof rilancioMin === 'string') {
            // Se è stringa, rimuovi separatori migliaia e converti virgola in punto
            this.rilancioMinimo = parseFloat(rilancioMin.replace(/\./g, "").replace(",", "."));
        } else {
            // Se è già un numero, usa direttamente
            this.rilancioMinimo = Number(rilancioMin);
        }

        if (this.rilancioMinimo > 0) {
            $("#rialzo-minimo").html(UI.formatEuroCurrency(this.rilancioMinimo));
            $(".rilancio").removeClass("d-none");
        } else {
            $(".rilancio").addClass("d-none");
        }

        $("#numero-partecipanti").html(obj.NumeroPartecipanti);

        // ✅ Formatta anticipo
        const anticipoValore = obj.Anticipo ?? 0;
        const anticipo = await this.formatTempoAnticipo(anticipoValore);

        // ✅ Formatta prolungamento
        const prolungamentoValore = obj.Prolungamento ?? 0;
        const prolungamento = await this.formatTempoProlungamento(prolungamentoValore);

        // ✅ Estensioni
        const estensioniValore = obj.Estensioni ?? 0;

        // ✅ numero prolungamento
        const prolungamentiAttivati = obj.NumeroProlungamento ?? 0;
        // ✅ Forza la conversione a numero per sicurezza
        let statoGara: number = Number(obj.Stato);

        // ✅ Controlla se tutti i valori sono 0 per nascondere i prolungamenti
        if (anticipoValore === 0 && prolungamentoValore === 0 && estensioniValore === 0) {
            $(".prolungamenti").addClass("d-none");
            $(".prolungamenti-attivati").addClass("d-none");
        } else {
            $(".prolungamenti").removeClass("d-none");
            if (statoGara == 1 || statoGara == 6) {
                $(".prolungamenti-attivati").addClass("d-none");
            } else {
                $(".prolungamenti-attivati").removeClass("d-none");
            }
        }

        $("#anticipo").html(anticipo);
        $("#prolungamento").html(prolungamento);
        if (estensioniValore === 0) {
            $("#estensioni").html(t("common.illimitati"));
        } else {
            $("#estensioni").html(estensioniValore);
        }
        $("#numero-prolungamento").html(prolungamentiAttivati);

        //DATI PARTIAL "BoxATStatoAsta/_SituazioneCorrente"
        $("#migliore-offerta").html(UI.formatEuroCurrency(obj.PrezzoCorrente));

        //DATI MODALE RILANCIO
        $("#modal-migliore-offerta").html(UI.formatEuroCurrency(obj.PrezzoCorrente));

        if (obj.RialzoMinimo > 0) {
            $("#modal-rialzo-minimo").html(UI.formatEuroCurrency(obj.RialzoMinimo));
            const rilancioMinimo = obj.PrezzoCorrente + obj.RialzoMinimo;
            $("#modal-rilancio-minimo").html(UI.formatEuroCurrency(rilancioMinimo));
        } else {
            $("#divRialzoMin").addClass("d-none");
            $("#modal-rilancio-minimo").html(t("asta.rilancioMaggioreDi") + UI.formatEuroCurrency(obj.PrezzoCorrente));
        }

        console.info(`🔄 Miglior offerente: ${obj.MigliorOfferente}`);
        console.info(`🔄 Miglior offerente precedente: ${this.migliorOfferentePrecedente}`)
        // ✅ Salva il miglior offerente precedente PRIMA di aggiornare
        if (this.migliorOfferente !== obj.MigliorOfferente && this.migliorOfferente !== null) {
            this.migliorOfferentePrecedente = this.migliorOfferente;
            console.info(`🔄 Miglior offerente cambiato: ${this.migliorOfferentePrecedente} → ${obj.MigliorOfferente}`);
        }

        this.migliorOfferente = obj.MigliorOfferente;
        this.miglioreOfferta = obj.PrezzoCorrente;

        //***** Stato gara *****/
        // - 1 da iniziare,
        // - 2 in corso,
        // - 3 conclusa,
        // - 4 aggiudicata,
        // - 5 chiusa,
        // - 6 sospesa

        const today = new Date();
        const inizioasta = new Date(obj.DataInizio);
        const fineasta = new Date(obj.DataFine);



        // ✅ Validazione: se non è un numero valido, usa 0 come fallback
        if (isNaN(statoGara)) {
            console.warn(`⚠️ Stato gara non valido ricevuto: ${obj.Stato}, uso 0 come fallback`);
            statoGara = 0;
        }

        if (today < inizioasta) {
            statoGara = 1;
        }
        else if ((today > fineasta && (statoGara == 1 || statoGara == 2)) || statoGara == 3) {
            $("#div-count-down").addClass("d-none");
            statoGara = 3;
            this.astaConclusa = true;
            this.StopPolling();
        } else {

            if (statoGara == 1) {
                $("#div-count-down").addClass("d-none");

            } else if (statoGara == 2) {
                // ✅ Inizializza countdown SOLO se non è già attivo
                if (!this.countdownInitialized) {
                    this.CountDown(fineasta, $("#div-count-down")[0] as HTMLDivElement);
                    this.countdownInitialized = true;
                }
                $("#div-count-down").removeClass("d-none");
                $("#div-stato-gara").addClass("d-none");

                if (this.userIdAT != this.migliorOfferente && this.UserId != this.venditoreId && this.statoIscrizione == 3) {
                    $("#btnRilancia").removeClass("d-none");
                } else {
                    $("#btnRilancia").addClass("d-none");
                }
            }
        }

        // ✅ Salva lo stato corrente
        const statoGaraPrecedente: number = this.statoGaraCorrente;
        this.statoGaraCorrente = statoGara;

        // ✅ Log dettagliato se lo stato è cambiato
        if (statoGaraPrecedente !== statoGara) {
            console.info(`🔄 Stato gara cambiato: ${statoGaraPrecedente} → ${statoGara} (tipo: ${typeof statoGara})`);
        } else {
            console.info(`✅ Stato gara corrente: ${statoGara} (tipo: ${typeof statoGara})`);
        }

        this.aggiornaStatoGara(statoGara);

        let boxStatoOfferta = $("#box-stato-offerta");
        if (this.userIdAT == this.migliorOfferente && this.statoIscrizione == 3) {
            boxStatoOfferta.removeClass("d-none");
            if (this.statoGaraCorrente <= 3) {
                boxStatoOfferta.html(``);
                boxStatoOfferta.append(`
               <div class="bg-success lh-sm rounded-bottom p-4 d-flex flex-nowrap justify-content-center align-items-center gap-3 text-light ">
                    <span class="material-symbols-outlined md-48">thumb_up</span>
                    <span class="fw-bold fs-6">${t("asta.lblMiglioreOfferente")}</span>
                </div>
            `);
            } else if (this.userIdAT == obj.Aggiudicatario){
                boxStatoOfferta.html(``);
                boxStatoOfferta.append(`
               <div class="bg-success lg-sm rounded-bottom p-4 d-flex flex-nowrap justify-content-center align-items-center gap-3 text-light ">
                    <span class="material-symbols-outlined md-48">trophy</span>
                    <span class="fw-bold fs-6">${t("asta.lblComplimentiAggiudicatario")}</span>
                </div>
            `);
            }
        } else {
            boxStatoOfferta.addClass("d-none");
        }

    }

    private async getTipoCauzioneLabel(tipoCauzioneId: number): Promise<string> {
        let label = "";

        switch (tipoCauzioneId) {
            case 1:
                label = "";
                break;
            case 2:
                label = t("common.percPrezzoOfferto");
                break;
            case 3:
                label = t("common.percPrezzoBase");
                break;
            case 4:
                label = t("common.nessunaCauzione");
                break;
            default:
                label = "";
                break;
        }

        return label;
    }

    private async formatTempoAnticipo(anticipoMin: number): Promise<string> {
        if (anticipoMin <= 0) {
            return "-";
        }

        let value: number;
        let label: string;

        if (anticipoMin >= 1440) {
            // Converti in giorni
            value = Math.floor(anticipoMin / 1440);
            label = value === 1 ? t("common.giorno") : t("common.giorni");
        } else if (anticipoMin >= 60) {
            // Converti in ore
            value = Math.floor(anticipoMin / 60);
            label = value === 1 ? t("common.ora") : t("common.ore");
        } else {
            // Mantieni in minuti
            value = anticipoMin;
            label = value === 1 ? t("common.minuto") : t("common.minuti");
        }

        return `${value} ${label}`;
    }

    private async formatTempoProlungamento(prolungamentoMin: number): Promise<string> {
        if (prolungamentoMin <= 0) {
            return "-";
        }

        let value: number;
        let label: string;

        if (prolungamentoMin >= 1440) {
            value = Math.floor(prolungamentoMin / 1440);
            label = value === 1 ? t("common.giorno") : t("common.giorni");
        } else if (prolungamentoMin >= 60) {
            value = Math.floor(prolungamentoMin / 60);
            label = value === 1 ? t("common.ora") : t("common.ore");
        } else {
            value = prolungamentoMin;
            label = value === 1 ? t("common.minuto") : t("common.minuti");
        }

        return `${value} ${label}`;
    }

    private PopolaTabella(obj: any) {
        let tblbody = "";
        const migliorOfferente = this.migliorOfferente;
        const miglioreOfferta = this.miglioreOfferta;
        const userId = this.userIdAT;

        // Salva l'indice della riga espansa (se presente)
        this.expandedRowIndexes = [];
        const $oldRows = $("#tbl-offerte-at-body tr");
        $oldRows.each((idx, el) => {
            if ($(el).hasClass("expand-row-details") && !$(el).hasClass("d-none")) {
                this.expandedRowIndexes.push(idx - 1); // la riga principale è quella precedente
            }
        });

        if (Array.isArray(obj) && obj.length > 0) {
            for (const item of obj) {
                const isMiglioreOfferta = (item.IdAna === migliorOfferente && item.Importo === miglioreOfferta);
                const isRilancioAnnullato = item.Confermata === false;
                let cssTr = "";
                if (isMiglioreOfferta) cssTr = "bestOffer";
                else if (isRilancioAnnullato) cssTr = "cancelledOffer";

                const nomeVisualizzato = (item.IdAna == userId ? this.offerente : item.Alias);

                let badge = "";
                if (isMiglioreOfferta) {
                    badge = `<span class='badge text-bg-success lh-sm'>${t("asta.miglioreOfferta")}</span>`;
                } else if (isRilancioAnnullato) {
                    badge = `<span class='badge text-bg-secondary lh-sm'>${t("asta.rilancioAnnullato")}</span>`;
                }

                tblbody += `
                <tr class="${cssTr}">
                    <th scope="row" class="d-block d-sm-table-cell fw-normal">
                        <div class="d-flex align-items-center">
                            <div role="button" class="btn-expand-row">
                                <div class="arrow arrow--small arrow--down me-2">
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                            <div class="d-flex flex-nowrap align-items-center">
                                <span class="whiteSpace-nowrap">${nomeVisualizzato}</span>
                            </div>
                        </div>
                    </th>
                    <td data-label="Importo offerto">
                        <span class="d-flex justify-content-between">
                            ${UI.formatEuroCurrency(item.Importo)} ${badge}
                        </span>
                    </td>
                    <td data-label="Data presentazione offerta" class="col-hide-lg">
                        <span class="whiteSpace-nowrap">${UI.formatDateIsoToIt(item.Data)} ore ${UI.formatTimeIsoToHms(item.Data)}</span>
                    </td>
                </tr>
                <tr class="expand-row-details d-none">
                    <td colspan="3" class="bg-body-secondary px-5 lh-lg small"></td>
                </tr>
            `;
            }
        } else {
            tblbody = `<tr><td colspan="3" class="text-center">${t("asta.nessunaOffertaDisponibile")}</td></tr>
                         <tr class="expand-row-details d-none">
                                <td colspan="3" class="bg-body-secondary px-5 lh-lg small"></td>
                            </tr>
                        `;
        }

        $("#tbl-offerte-at-body").html(tblbody);

        if (window.updateExpandButtons) window.updateExpandButtons();
        // Ri-associa i listener ai nuovi .btn-expand-row
        $(".tablePlus .btn-expand-row").off("click").on("click", function () {
            const btn = this;
            const tr = btn.closest('tr');
            if (!tr) return;
            const detailTr = tr.nextElementSibling as HTMLElement | null;
            if (!detailTr || !detailTr.classList.contains('expand-row-details')) return;

            const arrow = btn.querySelector('.arrow');
            if (!detailTr.classList.contains('d-none')) {
                detailTr.classList.add('d-none');
                const td = detailTr.querySelector('td');
                if (td) td.innerHTML = '';
                if (arrow) arrow.classList.remove('active');
                return;
            }

            // Altrimenti, mostra e popola con le colonne nascoste
            const hiddenCells: string[] = [];
            const table = tr.closest('table');
            if (!table) return;
            const ths = table.querySelectorAll('thead th');
            const cells = tr.children;
            for (let i = 0; i < ths.length; i++) {
                const th = ths[i];
                const cell = cells[i];
                if (!cell) continue;
                if (getComputedStyle(cell).display === 'none') {
                    const label = th.textContent?.trim() ?? '';
                    const value = cell.innerHTML.trim();
                    hiddenCells.push('<div class="mb-1"><strong>' + label + '</strong> ' + value + '</div>');
                }
            }
            const td = detailTr.querySelector('td');
            if (td) td.innerHTML = hiddenCells.join('');
            detailTr.classList.remove('d-none');
            if (arrow) arrow.classList.add('active');
        });

        // Dopo aver rigenerato la tabella, riapri la riga espansa se necessario
        if (this.expandedRowIndexes.length > 0) {
            const $rows = $("#tbl-offerte-at-body tr");
            this.expandedRowIndexes.forEach(idx => {
                const $mainRow = $rows.eq(idx);
                if ($mainRow.length) {
                    $mainRow.find(".btn-expand-row").trigger("click");
                    $mainRow.find(".arrow").addClass("active"); // forza la freccia aperta
                }
            });
        }
    }

    private PopolaTabellaOfferteIniziali(obj: any) {
        let tblbody = "";
        const userId = this.userIdAT;

        if (Array.isArray(obj) && obj.length > 0) {
            for (const item of obj) {
                const nomeVisualizzato = (item.IdAna == userId ? this.offerente : item.Alias);
                console.info("Offerta: " + JSON.stringify(item));
                tblbody += `
                            <tr>
                                <th scope="row" class="d-block d-sm-table-cell fw-normal">
                                    <div class="d-flex align-items-center">
                                        <div role="button" class="btn-expand-row">
                                            <div class="arrow arrow--small arrow--down me-2">
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <span class="whiteSpace-nowrap">${nomeVisualizzato}</span>
                                        </div>
                                    </div>
                                </th>
                                <td data-label="Importo offerto">${UI.formatEuroCurrency(item.PrezzoOfferto)}</td>
                                <td data-label="Cauzione versata" class="col-hide-sm">
                                    <span class="whiteSpace-nowrap">${UI.formatEuroCurrency(item.ImportoCauzione)}</span>
                                </td>
                                <td data-label="Tempo rogito/consegna" class="col-hide-md">${item.TerminiPagamentoSaldo} giorni</td>
                                <td data-label="Data presentazione offerta" class="col-hide-lg">
                                    <span class="whiteSpace-nowrap">${UI.formatDateIsoToIt(item.DataOfferta)} ore ${UI.formatTimeIsoToHms(item.DataOfferta)}</span>
                                </td>
                            </tr>
                            <tr class="expand-row-details d-none">
                                <td colspan="5" class="bg-body-secondary px-5 lh-lg small"></td>
                            </tr>
                        `;
            }

            $("#tbl-offerte-iniziali-body").html(tblbody);
            $("#lista-offerte-iniziali").removeClass("d-none");
            attachExpandListeners();
        } else {
            $("#lista-offerte-iniziali").addClass("d-none");
        }

    }

    private async StatoIscrizione(obj: any) {
        // obj
        // "StatoIscrizione": int,
        // "StatoCauzione": int,
        // "Motivazione": string

        //StatoIscrizione Stato dell’iscrizione. Valori ammessi:
        //RICHIESTA_ISCRIZIONE = 0,
        //ISCRITTO = 1,
        //NON_AMMESSO = 2,
        //AMMESSO = 3,
        //ESCLUSO = 4

        //StatoCauzione Stato della cauzione. Valori ammessi:
        //SCONOSCIUTO = -1,
        //NON_VERIFICATA = 0,
        //ACCREDITATA = 1,
        //NON_ACCREDITATA = 2,
        //CONFISCATA = 3

        console.info("StatoIscrizione --> " + obj.StatoIscrizione);
        console.info("StatoCauzione --> " + obj.StatoCauzione);
        console.info("Motivazione --> " + obj.Motivazione);

        this.statoIscrizione = obj.StatoIscrizione;

        let boxStato = $("#box-stato-iscrizione");

        if (!this.astaConclusa && (this.statoIscrizione == 0 || this.statoIscrizione == 1)) {
            //Richiesta iscrizione o iscritto
            boxStato.html(``);
            boxStato.append(`
                <div class="bg-warning lh-sm rounded-bottom p-4 d-flex flex-nowrap justify-content-center align-items-center gap-3 text-dark ">
                    <span class="material-symbols-outlined md-48">hourglass</span>
                    <span class="fw-bold fs-6">${t("asta.lblOffertaInCorsoValutazione")}</span>
                </div>
            `);
        } else if (this.statoIscrizione == 2 || this.statoIscrizione == 4) {
            // Non ammesso o escluso
            boxStato.html(``);
            boxStato.append(`
                <div class="bg-danger lh-sm rounded-bottom p-4 d-flex flex-nowrap justify-content-center align-items-center gap-3 text-light ">
                    <span class="material-symbols-outlined md-48">block</span>
                    <span class="fw-bold fs-6">${t(`asta.lblNonAmmesso`)}</span>
                </div>`);
        } else {
            boxStato.html(``);
        }

    }

    private aggiornaStatoGara(stato: number) {
        console.info("Stato gara --> " + stato);
        const el = document.getElementById('stato-gara');
        const divEl = document.getElementById('div-stato-gara');
        if (!el || !divEl) return;

        const $el = $(el); // Converti in oggetto jQuery
        const $divEl = $(divEl); // Converti in oggetto jQuery
        $el.text('...'); // Placeholder mentre carica

        if (stato != 1 && stato != 2) {
            $divEl.removeClass('d-none'); // ✅ Rimuovi classe
            $el.text(t(`asta.lblStatoGaraAT${stato}`));
        } else {
            $el.text("");
            $divEl.addClass('d-none'); // ✅ Aggiungi classe
        }
    }

    private CountDown(dataOraFine: Date, divCountdown: HTMLDivElement) {
        const now = new Date();
        const diffMs = dataOraFine.getTime() - now.getTime();

        if (diffMs <= 0) {
            console.log("Asta conclusa");
            divCountdown.remove();
            this.countdownInitialized = false;
            return;
        }

        const days = Math.floor(diffMs / (24 * 60 * 60 * 1000));
        const hours = Math.floor((diffMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
        const minutes = Math.floor((diffMs % (60 * 60 * 1000)) / (60 * 1000));
        const seconds = Math.floor((diffMs % (60 * 1000)) / 1000);

        const $countdown = $("#countdown");
        if ($countdown.children().length === 0) {
            $countdown.html(`
            <span class="countdown-days">0</span>g: 
            <span class="countdown-hours">0</span>h: 
            <span class="countdown-minutes">0</span>m: 
            <span class="countdown-seconds">0</span>s
        `);
        }

        // ✅ Salva l'ID del timer restituito da startCountdown
        this.countdownTimerId = startCountdown(
            days, hours, minutes, seconds,
            (remainingTime) => {
                $countdown.find(".countdown-days").text(remainingTime.days);
                $countdown.find(".countdown-hours").text(remainingTime.hours);
                $countdown.find(".countdown-minutes").text(remainingTime.minutes);
                $countdown.find(".countdown-seconds").text(remainingTime.seconds);
            },
            () => {
                console.log("Asta conclusa");
                divCountdown.remove();
                this.countdownInitialized = false;
                this.countdownTimerId = null; // ✅ Reset
            }
        );
    }

    /**
      * Converte un importo dal formato italiano (1.250,50) a float.
      *
      * @param {string} value - Importo in formato italiano
      * @returns {number} Valore float
      */
    private parseItalianCurrency(value: string): number {
        const cleanValue = value.toString().replace(/\./g, '').replace(',', '.');
        return parseFloat(cleanValue);
    }

    private async InviaRilancio() {

        let rilancio = $("#txtRilancio").val() as string;
        let importoRilancio = rilancio ? this.parseItalianCurrency(rilancio) : 0;

        // Validazione base
        if (!importoRilancio || importoRilancio <= 0) {
            $("#ATResultMessage")
                .removeClass("text-success")
                .addClass("text-danger")
                .html(t("asta.inserisciImportoValido"));
            return;
        }

        // Validazione rilancio minimo
        if (this.miglioreOfferta !== null && importoRilancio < (this.miglioreOfferta + this.rilancioMinimo))
        {
            if (this.rilancioMinimo > 0) {

                const importoMinimoRichiesto = this.miglioreOfferta + this.rilancioMinimo;
                $("#ATResultMessage")
                    .removeClass("text-success")
                    .addClass("text-danger")
                    .html(t("asta.importoMinimoRilancio", { amount: UI.formatEuroCurrency(importoMinimoRichiesto) }));
            } else {
                $("#ATResultMessage")
                    .removeClass("text-success")
                    .addClass("text-danger")
                    .html(t("asta.importoMinimoRilancioMaggiore", { amount: UI.formatEuroCurrency(this.miglioreOfferta) }));
            }
            return;
        }

        // Nascondi la modale principale
        $("#modalRilancioAsta").addClass("d-none");

        UI.confirm("", "Vuoi effettuare il rilancio?", "", async (result) => {

            // Quando la modale di conferma si chiude, mostra di nuovo la modale principale
            $("#modalRilancioAsta").removeClass("d-none");

            if (!result) {
                return;
            }
            $("#btnRilancioAsta").prop("disabled", true).html(`<span class="spinner-border spinner-border-sm me-2"></span>${t("common.invioInCorso")}`);
            $("#ATResultMessage").html("");

            try {

                let venditoreIdRa = Number($("#hdVenditoreId").val());
                let venditaId = Number($("#hdVenditaId").val());
                this.migliorOfferentePrecedente = this.migliorOfferente;

                const dataRilancio = {
                    IdAna: this.userIdAT,
                    Idv: this.IdAsteTelematiche,
                    Pin: this.pin,
                    Importo: importoRilancio
                }

                const data = {
                    venditaId: venditaId,
                    VenditoreId: venditoreIdRa,
                    ATOfferentePrecedenteId: this.migliorOfferentePrecedente,
                    Rilancio: dataRilancio
                }

                console.info("Rilancio: ", data);

                const url = window.BaseUrlWebApi + "AsteTelematiche/Rilancio";
                const response = await this.auth.fetchWithAuth("POST " + url, {
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data),
                });

                console.info("Risposta rilancio:", response);

                if (response.Success) {
                    // Successo

                    // ✅ SOLO DOPO riavvia il polling
                    this.StarPolling();

                    $("#modalRilancioAsta").modal("hide");

                    UI.confirmOneButton("", t("asta.rilancioMigliorOfferente"), "OK")

                } else {
                    // ✅ Errore, ma NON entra nel catch
                    let error = response.ErrorMessage;

                    console.info("response.ErrorMessage : " + error);
                    $("#ATResultMessage")
                        .removeClass("text-success")
                        .addClass("text-danger")
                        .html(error);
                }

            } catch (error: any) {
                // ✅ Gestiamo l'errore restituito dalla Web API
                console.error("Errore di rete nel rilancio:", error);

                $("#ATResultMessage")
                    .removeClass("text-success")
                    .addClass("text-danger")
                    .html(t("asta.erroreConnessione"));
            } finally {
                // Ripristina pulsante
                $("#btnRilancioAsta").prop("disabled", false).html(t("asta.inviaRilancio"));
            }
        });
    }



}

export default AtStatoAsta;
